import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';

/**
 * A guest's "Se connecter" and "S'inscrire" - core's two header links
 * (HeaderSecondary's logIn and signUp items) - grouped in one "Connexion"
 * menu, requested 2026-10-05. Same actions as core's (its two modals,
 * loaded on demand), and "S'inscrire" only where core showed it (sign-ups
 * allowed); same place too, last on the right.
 */
export default function addLogInMenu() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!items.has('logIn')) return;
    const canSignUp = items.has('signUp');
    items.remove('logIn');
    items.remove('signUp');
    items.add('champisLogInMenu', m(Dropdown, {
      buttonClassName: "Button Button--link",
      menuClassName: "Dropdown-menu--right",
      label: app.translator.trans('champis-users.forum.log_in_menu.label'),
      accessibleToggleLabel: app.translator.trans('champis-users.forum.log_in_menu.toggle_accessible_label')
    }, m(Button, {
      icon: "fas fa-sign-in-alt",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('core.forum.header.log_in_link')), canSignUp ? m(Button, {
      icon: "fas fa-user-plus",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, app.translator.trans('core.forum.header.sign_up_link')) : null), 0);
  });
}